import { Cross } from '@components/icons'
import s from './Tooltip.module.css'
import { ReactNode, FC } from 'react'

interface Props {
  title?: string
  message?: string
  image?: any
  children: ReactNode
  className?: string
  arrowStyle?: string
  position?: string
  link?: any
  container?: string
  codePromotion?: any
  onClickSetter?: () => void
  styleClose?: string
}

const Tooltip: FC<Props> = ({
  title,
  message,
  image,
  children,
  className,
  arrowStyle,
  position,
  link,
  container,
  codePromotion,
  onClickSetter,
  styleClose,
}) => {
  return (
    <div className={container}>
      {children}
      <div className={`${'absolute flex items-center'} ${position}`}>
        <div className={arrowStyle}></div>
        <span className={`${s.spanDp} ${className}`}>
          <div className={`${s.close} ${styleClose}`} onClick={onClickSetter}>
            <Cross className="h-6 w-6" />
          </div>
          <h3 className={s.titleCheckbox}>
            {title} <span className="align-sub">{image}</span>
          </h3>
          <p className="text-[11px] text-center px-2 py-1 ">
            {message} {codePromotion}
            {link}
          </p>
        </span>{' '}
      </div>
    </div>
  )
}

export default Tooltip
